import {configureStore} from "@reduxjs/toolkit";
import sidebarSlice from "./slices/sidebarSlice";
import credentialsSlice from "./slices/credentialsSlice";

const store=configureStore({
    reducer:{
        sidebarSlice:sidebarSlice.reducer,
        credentialsSlice:credentialsSlice.reducer
    }
});

export default store;